export const BookAppointment3 = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0502 7.24233C12.0502 6.66244 11.5801 6.19233 11.0002 6.19233C10.4203 6.19233 9.95024 6.66244 9.95024 7.24233L12.0502 7.24233ZM13.8187 12.9897C14.3986 12.9897 14.8687 12.5196 14.8687 11.9397C14.8687 11.3598 14.3986 10.8897 13.8187 10.8897V12.9897ZM11.0002 10.5305H9.95024H11.0002ZM9.95024 7.24233V10.5305H12.0502L12.0502 7.24233L9.95024 7.24233ZM19.345 11.0002C19.345 15.6089 15.6089 19.345 11.0002 19.345V21.445C16.7687 21.445 21.445 16.7687 21.445 11.0002H19.345ZM11.0002 19.345C6.39155 19.345 2.65547 15.6089 2.65547 11.0002H0.555469C0.555469 16.7687 5.23175 21.445 11.0002 21.445V19.345ZM2.65547 11.0002C2.65547 6.39155 6.39155 2.65547 11.0002 2.65547V0.555469C5.23175 0.555469 0.555469 5.23175 0.555469 11.0002H2.65547ZM11.0002 2.65547C15.6089 2.65547 19.345 6.39155 19.345 11.0002H21.445C21.445 5.23175 16.7687 0.555469 11.0002 0.555469V2.65547ZM12.4095 12.9897H13.8187V10.8897H12.4095V12.9897ZM9.95024 10.5305C9.95024 11.8887 11.0513 12.9897 12.4095 12.9897V10.8897C12.2111 10.8897 12.0502 10.7289 12.0502 10.5305H9.95024Z"
          fill="#F85663"
        />
      </svg>
    </>
  );
};
